import React from "react";
import "./profile-briefs.scss";

import { Text } from "@ui-kit";

const BillsItem = ({ item = {} }) => {
  const { title, earn, description, info } = item;

  return (
    <div className="brief-card">
      <div className="card-header">
        <Text as="h5">{title || ""}</Text>
        <Text as="h5" className="earn-badge">
          {earn || ""}
        </Text>
      </div>

      <div className="card-body">
        <Text as="h6">{description || ""}</Text>

        <div className="info-grid">
          {info.map((itm, index) => (
            <div className="info-item" key={`info-${index}`}>
              <Text as="h6" className="description">
                {itm.description || ""}
              </Text>
              <Text as="h6" className="title">
                {itm.title || ""}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BillsItem;
